import React from "react";
import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import LogoBlue from "images/LivingSpaceLogoColour-1.svg";
import { RichText } from "prismic-reactjs";
import { withStyles } from "@material-ui/styles";

const styles = theme => ({
  logo: {
    width: "150px",
    [theme.breakpoints.up("lg")]: {
      width: "150px"
    }
  }
});

function TitleCaptionText(props) {
  const { classes, data, logo, titlecomponent, xs, md, lg } = props;
  const xsVal = xs ? xs : 12;
  const mdVal = md ? md : 6;
  const lgVal = lg ? lg : 6;
  return (
    <Grid container justify="center">
      <Grid item xs={xsVal} md={mdVal} lg={lgVal}>
        <Box
          display="flex"
          justifyContent="center"
          alignItems={
            data.align_text ? data.align_text.toLowerCase() : "center"
          }
          flexDirection="column"
        >
          {data.show_hayfield_logo && (
            <Box
              display="flex"
              justifyContent="center"
              flexDirection="column"
              mb={2}
            >
              <LogoBlue className={classes.logo} />
            </Box>
          )}
          {data.title && data.title[0] && (
            <Typography
              component={`${titlecomponent ? titlecomponent : "h2"}`}
              variant={`${titlecomponent ? titlecomponent : "h2"}`}
              color="textPrimary"
              gutterBottom
              align={data.align_text ? data.align_text.toLowerCase() : "center"}
            >
              {data.title[0].text}
            </Typography>
          )}
          {data.caption && data.caption[0] && (
            <Box pt={2} pb={4}>
              <Typography
                component="p"
                variant="h5"
                color="textPrimary"
                align={
                  data.align_text ? data.align_text.toLowerCase() : "center"
                }
              >
                {data.caption[0].text}
              </Typography>
            </Box>
          )}
          {data.text && (
            <Typography
              component="span"
              variant="subtitle1"
              align={data.align_text ? data.align_text.toLowerCase() : "center"}
            >
              <RichText render={data.text} />
            </Typography>
          )}
        </Box>
      </Grid>
    </Grid>
  );
}

TitleCaptionText.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  logo: PropTypes.bool,
  titlecomponent: PropTypes.string,
  xs: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number
};

export default withStyles(styles)(TitleCaptionText);
